import { Link } from 'react-router-dom';

export const HeroSection = () => {
  return (
    <section className="w-full bg-body">
      <div className="m-auto px-10 md:px-16 lg:px-24 max-w-108">
        <div className="flex flex-col md:flex-row justify-between items-center py-12 px-4">
          <div className="flex flex-col items-center md:items-start">
            <h1 className="font-potter text-4xl smart:text-5xl md:text-6xl lg:text-7xl font-normal text-background leading-4">
              Hogwarts Shop
            </h1>
            <p className="mt-8 lg:mt-12 w-full md:w-3/4 font-poppins font-normal text-sm smart:text-base lg:text-xl text-background leading-6">
              Explore a selection of best-loved Harry Potter products, including bespoke collectables, unique wands,
              souvenirs, delicious confectionery, fan-favourites and more, perfect for gifting any witch or wizard to
              add to their collection.
            </p>
            <p className="w-full md:w-3/4 font-poppins font-normal text-sm smart:text-base lg:text-xl text-background leading-6">
              Say <span>the Magic Word</span> to find the Way!
            </p>
            <Link
              className="p-1 mt-4 rounded-xl h-10 w-28 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border border-transparent text-font hover:bg-none hover:border-borderColor hover:text-borderColor duration-300"
              to="/catalog">
              Dissendium!
            </Link>
          </div>
          <img className="md:w-1/2" src="/Assets/Images/items.png" alt="Shop items" />
        </div>
      </div>
    </section>
  );
};
